<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-body">
      <form @submit.prevent="submit">
        <DateFormGroup v-model="internal.year" label="Year" format="YYYY" original-format="YYYY"/>

        <TextFormGroup v-model="internal.chanceWithRenewal" label="Chance (with renewal)"/>

        <TextFormGroup v-model="internal.chanceWithoutRenewal" label="Chance (without renewal)"/>

        <TextFormGroup v-model="internal.priceIncreaseValue" label="Price Increase Value"/>

        <TextFormGroup v-model="internal.newValue" label="Avg. New Value pr. month"/>

        <SelectFormGroup
            v-model="internal.priceIncreaseMethod"
            label="Price Increase Method"
            :options="[{value: 'absolute', label: 'Absolute'}, {value: 'percentage', label: 'Percentage'}]"
        />

        <SelectFormGroup
            v-model="internal.portalId"
            label="Portal"
            placeholder="(all)"
            :options="portalOptions"
            :nullable="true"
        />

        <button type="submit" class="btn btn-block btn-black">
          <i class="fa fa-sync"/> Load
        </button>

        <button type="button" class="btn btn-block btn-link" @click="$emit('download')">
          <i class="fa fa-download"/> Download
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import DateFormGroup from '../../../vendor/forms/FormGroups/Block/Date'
import SelectFormGroup from '../../../vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '../../../vendor/forms/FormGroups/Block/Text'

export default {
  components: {DateFormGroup, SelectFormGroup, TextFormGroup},

  props: {
    parameters: {
      required: true,
      type: Object
    },

    portals: {
      required: true,
      type: Array
    }
  },

  model: {
    prop: 'parameters'
  },

  data() {
    return {
      internal: {...this.parameters}
    }
  },

  computed: {
    portalOptions() {
      return this.portals.map(portal => ({value: portal.id, label: portal.attributes.name}))
    }
  },

  methods: {
    submit() {
      this.$emit('input', {...this.internal})
    }
  }
}
</script>